import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/spelling_bee.json";
import fr from "@/locales/fr/puzzle-types/spelling_bee.json";

export const SPELLING_BEE_NS = "puzzle-types/spelling_bee";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerSpellingBeeTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", SPELLING_BEE_NS))
    i18n.addResourceBundle("en", SPELLING_BEE_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", SPELLING_BEE_NS))
    i18n.addResourceBundle("fr", SPELLING_BEE_NS, fr, true, true);
}
